import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator, __read, __spread, __values } from "tslib";
import Vue from 'vue';
import { isUndef } from '@/lib/utils';
var m = {
  namespaced: true,
  state: function state() {
    return {
      placard: [],

      /** 动态map */
      blogsMap: {},

      /** 动态列表 */
      blogIds: {},

      /**  动态详情 */
      blogDetail: {},

      /** 评论map */
      commentMap: {},

      /** 评论列表 */
      commentIds: {
        requesting: false
      },

      /** 评论map */
      replyMap: {},

      /** 回复列表 */
      replyIds: {
        requesting: false
      },

      /** 显示分享弹窗 */
      isShowShare: false,

      /** 导航栏 */
      nav: 'all',

      /** 线下活动列表 */
      offlineList: [],
      bannerUrl: [],

      /** 队伍动态 */
      moments: {},
      momentMap: {},
      followMoment: {
        list: [],
        loaded: false,
        req: false
      },
      followMomentMap: {}
    };
  },
  mutations: {
    loversRunCommit: function loversRunCommit(state, data) {
      return __awaiter(this, void 0, void 0, function () {
        var _a;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = state;
              return [4
              /*yield*/
              , data];

            case 1:
              _a.placard = _b.sent();
              sessionStorage.setItem('loversImg', JSON.stringify(data));
              return [2
              /*return*/
              ];
          }
        });
      });
    },
    //       loversRun(state,data:string) {
    // Vue.axios.get('/api/v1/activity/special_list', {
    //           params:{
    //             activity_id:data,
    //           },
    //       }).then(response=> {
    //         state.placard = response.data;
    //       });
    //       },
    initBlogs: function initBlogs(state, _a) {
      var key = _a.key;
      Vue.set(state.blogIds, key, {
        list: [],
        loaded: false,
        requesting: false
      });
    },

    /** 设置动态列表 */
    concatBlogs: function concatBlogs(state, _a) {
      var _b;

      var key = _a.key,
          data = _a.data;
      var blogIds = [];
      data.forEach(function (blog) {
        blogIds.push(blog.id);
        Vue.set(state.blogsMap, blog.id, blog);
      });

      (_b = state.blogIds[key].list).push.apply(_b, __spread(blogIds));
    },

    /**  设置请求 */
    setBlogsRequest: function setBlogsRequest(state, _a) {
      var key = _a.key,
          data = _a.data;
      state.blogIds[key].requesting = data;
    },

    /** 设置加载 */
    setBlogsLoad: function setBlogsLoad(state, _a) {
      var key = _a.key,
          data = _a.data;
      state.blogIds[key].loaded = data;
    },

    /** 删除一条动态 */
    removeBlog: function removeBlog(state, data) {
      var blogTypes = ['all', 'person', 'hot'];
      blogTypes.forEach(function (blogType) {
        var wrap = state.blogIds[blogType];

        if (wrap && wrap.list) {
          var list = wrap.list;

          if (list.includes(data.id)) {
            list.splice(list.indexOf(data.id), 1);
          }
        }
      });
    },

    /** 设置动态详情 */
    setBlogDetail: function setBlogDetail(state, _a) {
      var id = _a.id,
          data = _a.data;
      Vue.set(state.blogDetail, id, data);
    },

    /** 设置评论列表 */
    setComments: function setComments(state, _a) {
      var blogId = _a.blogId,
          list = _a.list;

      if (!state.commentIds[blogId]) {
        Vue.set(state.commentIds, blogId, {
          list: [],
          loaded: false
        });
      }

      var commentIds = [];
      list.forEach(function (comment) {
        commentIds.push(comment.id);
        Vue.set(state.commentMap, comment.id, comment);

        if (comment.replies.length > 0) {
          // 处理评论携带的最新两条回复
          var replyIds_1 = [];
          comment.replies.forEach(function (reply) {
            replyIds_1.push(reply.id);
            Vue.set(state.replyMap, reply.id, reply);
          });
          Vue.set(state.replyIds, comment.id, {
            list: [],
            loaded: false
          }); // 因为重新请求了数据，清空一下回复列表

          state.replyIds[comment.id].list = [];
          state.replyIds[comment.id].list = state.replyIds[comment.id].list.concat(replyIds_1);
        }
      });
      state.commentIds[blogId].list = state.commentIds[blogId].list.concat(commentIds);
    },

    /**  设置评论请求 */
    setCommentsRequest: function setCommentsRequest(state, data) {
      state.commentIds.requesting = data;
    },

    /** 设置评论加载 */
    setCommentsLoad: function setCommentsLoad(state, _a) {
      var blogId = _a.blogId,
          loaded = _a.loaded;
      state.commentIds[blogId].loaded = loaded;
    },

    /** 设置回复列表 */
    setReplys: function setReplys(state, _a) {
      var commentId = _a.commentId,
          list = _a.list;
      var replyIds = [];

      if (!state.replyIds[commentId]) {
        Vue.set(state.replyIds, commentId, {
          list: [],
          loaded: false
        });
      }

      list.forEach(function (reply) {
        replyIds.push(reply.id);
        Vue.set(state.replyMap, reply.id, reply);
      });
      state.replyIds[commentId].list = state.replyIds[commentId].list.concat(replyIds);
    },

    /**  设置回复请求 */
    setReplysRequest: function setReplysRequest(state, data) {
      state.replyIds.requesting = data;
    },

    /** 设置回复加载 */
    setReplysLoad: function setReplysLoad(state, _a) {
      var commentId = _a.commentId,
          loaded = _a.loaded;
      state.replyIds[commentId].loaded = loaded;
    },

    /** 是否显示分享弹窗 */
    setShowShare: function setShowShare(state, data) {
      state.isShowShare = data;
    },

    /** 标记动态赞 */
    setBlogLike: function setBlogLike(state, data) {
      var count = data.like_count + 1;

      if (state.blogsMap[data.id]) {
        Vue.set(state.blogsMap[data.id], 'like_count', count);
        Vue.set(state.blogsMap[data.id], 'already_like', true);
      }

      if (state.blogDetail[data.id]) {
        Vue.set(state.blogDetail[data.id], 'like_count', count);
        Vue.set(state.blogDetail[data.id], 'already_like', true);
      }

      var moment = state.momentMap[data.id];

      if (moment) {
        moment.already_like = !moment.already_like;

        if (moment.already_like) {
          moment.like_count++;
        } else {
          moment.like_count--;
        }
      }
    },

    /** 取消动态赞 */
    setBlogDislike: function setBlogDislike(state, data) {
      var count = data.like_count - 1;

      if (state.blogsMap[data.id]) {
        Vue.set(state.blogsMap[data.id], 'like_count', count);
        Vue.set(state.blogsMap[data.id], 'already_like', false);
      }

      if (state.blogDetail[data.id]) {
        Vue.set(state.blogDetail[data.id], 'like_count', count);
        Vue.set(state.blogDetail[data.id], 'already_like', false);
      }

      var moment = state.momentMap[data.id];

      if (moment) {
        moment.already_like = !moment.already_like;

        if (moment.already_like) {
          moment.like_count++;
        } else {
          moment.like_count--;
        }
      }
    },

    /** 添加评论 */
    addBlogComment: function addBlogComment(state, _a) {
      var id = _a.id,
          content = _a.content;

      if (state.blogDetail[id]) {
        var count = state.blogDetail[id].comment_count + 1;
        Vue.set(state.blogDetail[id], 'comment_count', count);
      }

      if (state.blogsMap[id]) {
        var count = state.blogsMap[id].comment_count + 1;
        Vue.set(state.blogsMap[id], 'comment_count', count);
      }
    },

    /** 删除评论 */
    removeBlogComment: function removeBlogComment(state, _a) {
      var blogId = _a.blogId,
          comment = _a.comment;
      var count = state.blogDetail[blogId].comment_count - 1;
      Vue.set(state.blogDetail[blogId], 'comment_count', count); // 动态列表有这条数据

      if (state.blogsMap[blogId]) {
        Vue.set(state.blogsMap[blogId], 'comment_count', count);
      }

      state.commentIds[blogId].list.splice(state.commentIds[blogId].list.indexOf(comment.id), 1);
    },

    /** 删除回复 */
    removeReply: function removeReply(state, _a) {
      var commentId = _a.commentId,
          replyId = _a.replyId;
      state.replyIds[commentId].list.splice(state.replyIds[commentId].list.indexOf(replyId), 1);
      state.commentMap[commentId].reply_count--;
    },

    /** 设置导航栏 */
    setNav: function setNav(state, nav) {
      state.nav = nav;
    },

    /** 设置线下活动列表 */
    setOfflineList: function setOfflineList(state, list) {
      state.offlineList = list;
    },

    /** 设置顶部banner链接 */
    setBannerUrl: function setBannerUrl(state, url) {
      state.bannerUrl = url;
    },

    /**
     * 队伍动态信息
     */
    setMoments: function setMoments(state, _a) {
      var e_1, _b, _c;

      var teamId = _a.teamId,
          moments = _a.moments;
      var ids = [];

      try {
        for (var moments_1 = __values(moments), moments_1_1 = moments_1.next(); !moments_1_1.done; moments_1_1 = moments_1.next()) {
          var moment = moments_1_1.value;
          ids.push(moment.id);
          Vue.set(state.momentMap, moment.id, moment);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (moments_1_1 && !moments_1_1.done && (_b = moments_1["return"])) _b.call(moments_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      (_c = state.moments[teamId].list).push.apply(_c, __spread(ids));
    },
    setMomentLoaded: function setMomentLoaded(state, _a) {
      var teamId = _a.teamId,
          loaded = _a.loaded;
      state.moments[teamId].loaded = loaded;
    },
    setMomentReq: function setMomentReq(state, _a) {
      var teamId = _a.teamId,
          req = _a.req;
      state.moments[teamId].req = req;
    },

    /**
     * 关注动态
     */
    concatFollowMoments: function concatFollowMoments(state, _a) {
      var e_2, _b, _c;

      var moments = _a.moments;
      var ids = [];

      try {
        for (var moments_2 = __values(moments), moments_2_1 = moments_2.next(); !moments_2_1.done; moments_2_1 = moments_2.next()) {
          var moment = moments_2_1.value;
          ids.push(moment.id);
          Vue.set(state.followMomentMap, moment.id, moment);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (moments_2_1 && !moments_2_1.done && (_b = moments_2["return"])) _b.call(moments_2);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      (_c = state.followMoment.list).push.apply(_c, __spread(ids));
    },
    setFollowMomentLoaded: function setFollowMomentLoaded(state, _a) {
      var loaded = _a.loaded;
      state.followMoment.loaded = loaded;
    },
    setFollowMomentReq: function setFollowMomentReq(state, _a) {
      var req = _a.req;
      state.followMoment.req = req;
    }
  },
  actions: {
    /**
     * 获取动态列表
     * @param count 数量
     * @param last_id 最后一条id
     * @param mine 类型
     */
    getBlogs: function getBlogs(_a, _b) {
      var state = _a.state,
          commit = _a.commit,
          rootState = _a.rootState;
      var count = _b.count,
          lastId = _b.lastId,
          type = _b.type,
          userId = _b.userId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, response, rdata, list, list_1, list_1_1, blog;

        var e_3, _d;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (!userId) {
                userId = rootState.user.basicInfo.id;
              }

              key = type === 'person' ? userId : type;
              wrap = state.blogIds[key];

              if (!wrap) {
                commit('initBlogs', {
                  key: key
                });
                wrap = state.blogIds[key];
              }

              if (forceUpdate) {
                wrap.requesting = false;
                wrap.loaded = false;
              }

              if (!lastId && !forceUpdate && wrap.list.length > 0) {
                return [2
                /*return*/
                ];
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              commit('setBlogsRequest', {
                key: key,
                data: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/community/moment_list', {
                params: {
                  count: count,
                  last_id: lastId,
                  mine: type,
                  user_id: userId
                }
              })];

            case 1:
              response = _e.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                if (forceUpdate) {
                  wrap.list = [];
                }

                list = rdata.data;
                commit('concatBlogs', {
                  key: key,
                  data: list
                });

                try {
                  for (list_1 = __values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                    blog = list_1_1.value;
                    commit('user/setFollowInfo', {
                      userId: blog.user_id,
                      hasFollow: blog.has_follow
                    }, {
                      root: true
                    });
                  }
                } catch (e_3_1) {
                  e_3 = {
                    error: e_3_1
                  };
                } finally {
                  try {
                    if (list_1_1 && !list_1_1.done && (_d = list_1["return"])) _d.call(list_1);
                  } finally {
                    if (e_3) throw e_3.error;
                  }
                }

                if (list.length < count) {
                  commit('setBlogsLoad', {
                    key: key,
                    data: true
                  });
                }
              }

              commit('setBlogsRequest', {
                key: key,
                data: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 发表动态
     * @param content 文字
     * @param images 图片key数组
     * @param imageUrls 图片url数组
     * @param position 定位
     */
    setBlog: function setBlog(context, _a) {
      var content = _a.content,
          images = _a.images,
          imageUrls = _a.imageUrls,
          position = _a.position,
          sign_in_id = _a.sign_in_id;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/create_moment', {
                content: content,
                images: images,
                position: position,
                sign_in_id: sign_in_id
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取动态详情
     * @param id 动态id
     */
    getBlogDetail: function getBlogDetail(_a, id) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.blogDetail[id]) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/community/moment_detail', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setBlogDetail', {
                  id: id,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    loversRun: function loversRun(_a, id) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/special_list', {
                params: {
                  activity_id: id
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('loversRunCommit', rdata.data);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * 获取评论列表
     * @param id 动态id
     */
    getBlogComments: function getBlogComments(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var blogId = _b.blogId,
          lastId = _b.lastId,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var data, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              data = state.commentIds[blogId] ? state.commentIds[blogId] : {
                list: [],
                loaded: false
              };

              if (state.commentIds.requesting || data.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && !lastId) {
                data.list = [];
                data.loaded = false;
              }

              commit('setCommentsRequest', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/community/comment_list', {
                params: {
                  id: blogId,
                  count: count,
                  last_id: lastId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setComments', {
                  blogId: blogId,
                  list: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setCommentsLoad', {
                    blogId: blogId,
                    loaded: true
                  });
                }
              }

              commit('setCommentsRequest', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取回复列表
     * @param id 评论id
     */
    getBlogReply: function getBlogReply(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var commentId = _b.commentId,
          lastId = _b.lastId,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var data, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              data = state.replyIds[commentId] ? state.replyIds[commentId] : {
                list: [],
                loaded: false
              };

              if (state.replyIds.requesting || data.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && !lastId) {
                data.list = [];
                data.loaded = false;
              }

              commit('setReplysRequest', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/community/reply_list', {
                params: {
                  id: commentId,
                  count: count,
                  last_id: lastId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setReplys', {
                  commentId: commentId,
                  list: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setReplysLoad', {
                    commentId: commentId,
                    loaded: true
                  });
                }
              }

              commit('setReplysRequest', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 发表评论
     * @param content 文字儿
     * @param id 动态id
     */
    setBlogComment: function setBlogComment(context, _a) {
      var id = _a.id,
          content = _a.content;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/create_comment', {
                content: content,
                id: id
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('addBlogComment', {
                  id: id,
                  content: content
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 发表回复
     * @param content 文字儿
     * @param id (评论的id)
     * @param reply_to 回复某个用户的用户id
     * @param reply_id 回复的id
     */
    setBlogReply: function setBlogReply(context, _a) {
      var content = _a.content,
          id = _a.id,
          reply_to = _a.reply_to,
          reply_id = _a.reply_id;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/create_reply', {
                content: content,
                id: id,
                reply_to: reply_to,
                reply_id: reply_id
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 删除动态
     * @param id
     */
    deleteBlog: function deleteBlog(context, blog) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('api/v1/community/delete_moment', {
                id: blog.id
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('removeBlog', blog);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 删除评论
     * @param id 动态id
     * @param comment: 评论内容
     */
    deleteBlogComment: function deleteBlogComment(context, _a) {
      var blogId = _a.blogId,
          comment = _a.comment;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/delete_comment', {
                id: comment.id
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('removeBlogComment', {
                  blogId: blogId,
                  comment: comment
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 删除回复
     * @param id
     */
    deleteBlogReply: function deleteBlogReply(context, _a) {
      var commentId = _a.commentId,
          replyId = _a.replyId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/delete_reply', {
                id: replyId
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('removeReply', {
                  commentId: commentId,
                  replyId: replyId
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 点赞
     * @param id
     */
    setBlogLike: function setBlogLike(context, blog) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/like', {
                id: blog.id
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setBlogLike', blog);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 取消点赞
     * @param id
     */
    setBlogDislike: function setBlogDislike(context, blog) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/cancel_like', {
                id: blog.id
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setBlogDislike', blog);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 举报
     * @param id
     */
    setBlogReport: function setBlogReport(context, id) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/community/report', {
                id: id
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取线下活动列表
     */
    getOfflineList: function getOfflineList(_a) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/community/under_line_activity')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setOfflineList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 获取banner的url */
    getBannerUrl: function getBannerUrl(_a) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/community/community_banner')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setBannerUrl', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队成员列表
     * @param teamId
     * @param count
     * @param lastId
     * @param forceUpdate
     */
    getTeamMoments: function getTeamMoments(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          count = _b.count,
          lastId = _b.lastId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list, list_2, list_2_1, moment;

        var e_4, _d;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              if (isUndef(state.moments[teamId])) {
                Vue.set(state.moments, String(teamId), {
                  list: [],
                  loaded: false,
                  requesting: false
                });
              }

              wrap = state.moments[teamId];

              if (wrap.req || wrap && wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
                lastId = null;
              } else if (wrap) {
                lastId = wrap.list[wrap.list.length - 1];
              }

              commit('setMomentReq', {
                teamId: teamId,
                requesting: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/team_moments', {
                params: {
                  id: teamId,
                  count: count,
                  last_id: lastId
                }
              })];

            case 1:
              response = _e.sent();
              rdata = response.data;
              commit('setMomentReq', {
                teamId: teamId,
                requesting: false
              });

              if (rdata.status === 0) {
                list = rdata.data;
                commit('setMoments', {
                  teamId: teamId,
                  moments: list
                });

                try {
                  for (list_2 = __values(list), list_2_1 = list_2.next(); !list_2_1.done; list_2_1 = list_2.next()) {
                    moment = list_2_1.value;
                    commit('user/setFollowInfo', {
                      userId: moment.user_id,
                      hasFollow: moment.has_follow
                    }, {
                      root: true
                    });
                  }
                } catch (e_4_1) {
                  e_4 = {
                    error: e_4_1
                  };
                } finally {
                  try {
                    if (list_2_1 && !list_2_1.done && (_d = list_2["return"])) _d.call(list_2);
                  } finally {
                    if (e_4) throw e_4.error;
                  }
                }

                if (list.length < count) {
                  commit('setMomentLoaded', {
                    teamId: teamId,
                    loaded: true
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队成员列表
     * @param teamId
     * @param count
     * @param lastId
     * @param forceUpdate
     */
    getFollowMoments: function getFollowMoments(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var count = _b.count,
          lastId = _b.lastId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, response, rdata, list, list_3, list_3_1, moment;

        var e_5, _d;

        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              wrap = state.followMoment;

              if (wrap.req || wrap && wrap.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                wrap.loaded = false;
                wrap.list = [];
                lastId = null;
              } else if (wrap) {
                lastId = wrap.list[wrap.list.length - 1];
              }

              commit('setFollowMomentReq', {
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/user/follow_moment', {
                params: {
                  count: count,
                  last_id: lastId
                }
              })];

            case 1:
              response = _e.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatFollowMoments', {
                  moments: list
                });

                try {
                  for (list_3 = __values(list), list_3_1 = list_3.next(); !list_3_1.done; list_3_1 = list_3.next()) {
                    moment = list_3_1.value;
                    commit('user/setFollowInfo', {
                      userId: moment.user_id,
                      hasFollow: true
                    }, {
                      root: true
                    });
                  }
                } catch (e_5_1) {
                  e_5 = {
                    error: e_5_1
                  };
                } finally {
                  try {
                    if (list_3_1 && !list_3_1.done && (_d = list_3["return"])) _d.call(list_3);
                  } finally {
                    if (e_5) throw e_5.error;
                  }
                }

                if (list.length < count) {
                  commit('setFollowMomentLoaded', {
                    loaded: true
                  });
                }
              }

              commit('setFollowMomentReq', {
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;